<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-user-circle mr-2" />Daftar Admin
            </h5>
            <hr />
            <b-row>
                <!-- <b-col md="3">
                    <b-form-group label="Nama Admin">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col> -->
                <b-col md="12" class="text-right">
                    <b-form-group>
                        <b-button
                            variant="success"
                            :disabled="isBusy || isSubmitting"
                            @click="prepareCreate"
                        >
                            <i class="fa fa-plus mr-2" />Admin Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty> Tidak ada data admin. </template>
                <template v-slot:cell(nama)="row">
                    <span>{{ row.item.nama }}</span
                    ><br />
                    <small class="text-muted">{{ row.item.username }}</small>
                </template>
                <template v-slot:cell(role)="row">
                    <b-badge variant="dark" v-if="row.item.role_id == 1"
                        >Superadmin</b-badge
                    >
                    <b-badge variant="secondary" v-else>Admin</b-badge>
                </template>
                <template v-slot:cell(active)="row">
                    <b-badge variant="success" v-if="row.item.is_active == 1"
                        >Aktif</b-badge
                    >
                    <b-badge variant="danger" v-else>Nonaktif</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex">
                        <b-button
                            size="sm"
                            variant="warning"
                            v-b-tooltip.hover.top
                            title="Edit"
                            :disabled="isBusy || isSubmitting"
                            @click="prepareEdit(row.item)"
                        >
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                        <b-button
                            size="sm"
                            class="ml-2"
                            :variant="
                                row.item.is_active == 1 ? 'danger' : 'success'
                            "
                            v-b-tooltip.hover.top
                            :title="
                                row.item.is_active == 1
                                    ? 'Nonaktifkan'
                                    : 'Aktifkan'
                            "
                            :disabled="
                                (row.item.role_id == 1 &&
                                    row.item.is_active == 1) ||
                                isBusy ||
                                isSubmitting
                            "
                            @click="confirmToggle(row.item)"
                        >
                            <i class="fa fa-fw fa-power-off" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
        <b-modal
            id="m-create"
            title="Buat Admin Baru"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-form-group
                label="Nama Admin"
                :state="inputNameState"
                description="Nama lengkap admin."
                invalid-feedback="Nama minimal 4 karakter."
            >
                <b-form-input
                    v-model="input.name"
                    :state="inputNameState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Username"
                :state="inputUsernameState"
                description="Username untuk login."
                invalid-feedback="Username minimal 4 karakter."
            >
                <b-form-input
                    v-model="input.username"
                    :state="inputUsernameState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Password"
                :state="inputPasswordState"
                description="Password untuk login."
                invalid-feedback="Password minimal 4 karakter."
            >
                <b-form-input
                    type="password"
                    v-model="input.password"
                    :state="inputPasswordState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Ulangi Password"
                :state="inputConfirmPasswordState"
                description="Mohon ketik ulang password."
                invalid-feedback="Password tidak sama."
            >
                <b-form-input
                    type="password"
                    v-model="input.confirmPassword"
                    :state="inputConfirmPasswordState"
                    maxlength="100"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="
                        !(
                            inputNameState &&
                            inputUsernameState &&
                            inputPasswordState &&
                            inputConfirmPasswordState
                        ) ||
                        isBusy ||
                        isSubmitting
                    "
                    @click="confirmCreate"
                >
                    {{ isSubmitting ? "Membuat..." : "Buat Admin" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal
            id="m-edit"
            title="Ubah Data Admin"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <b-form-group
                label="Nama Admin"
                :state="editNameState"
                description="Nama lengkap admin."
                invalid-feedback="Nama minimal 4 karakter."
            >
                <b-form-input
                    v-model="edit.name"
                    :state="editNameState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Username"
                :state="editUsernameState"
                description="Username untuk login."
                invalid-feedback="Username minimal 4 karakter."
            >
                <b-form-input
                    v-model="edit.username"
                    :state="editUsernameState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Password Baru"
                :state="editPasswordState"
                description="Password untuk login. Kosongkan apabila tidak ingin diubah."
                invalid-feedback="Password minimal 4 karakter."
            >
                <b-form-input
                    type="password"
                    v-model="edit.password"
                    :state="editPasswordState"
                    maxlength="100"
                />
            </b-form-group>
            <b-form-group
                label="Ulangi Password Baru"
                :state="editConfirmPasswordState"
                description="Mohon ketik ulang password. Kosongkan apabila tidak ingin diubah."
                invalid-feedback="Password tidak sama."
            >
                <b-form-input
                    type="password"
                    v-model="edit.confirmPassword"
                    :state="editConfirmPasswordState"
                    maxlength="100"
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button
                    variant="primary"
                    :disabled="
                        !(
                            editNameState &&
                            editUsernameState &&
                            editPasswordState &&
                            editConfirmPasswordState
                        ) ||
                        isSubmitting ||
                        isBusy
                    "
                    @click="confirmEdit"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan Perubahan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            filter: {
                name: "",
            },

            input: {
                name: "",
                username: "",
                password: "",
                confirmPassword: "",
            },

            edit: {
                id: "",
                name: "",
                username: "",
                password: "",
                confirmPassword: "",
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                // { key: "name", label: "Nama Admin", sortable: true },
                // { key: "email", label: "Email", sortable: true },
                { key: "nama", label: "Nama Admin", sortable: true },
                { key: "role", label: "Administrasi", sortable: true },
                { key: "active", label: "Status", sortable: true },
                { key: "action", label: "Aksi", sortable: false },
            ],

            items: [],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            let getItems = this.getItems();

            Promise.all([getItems])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch((_) => {
                    this.initStatus = -1;
                });
        },

        prepareCreate() {
            this.input.name = "";
            this.input.username = "";
            this.input.password = "";
            this.input.confirmPassword = "";
            this.$bvModal.show("m-create");
        },

        confirmCreate() {
            let payload = {
                nama: this.input.name,
                username: this.input.username,
                password: this.input.password,
            };

            this.isSubmitting = true;

            this.$axios
                .post("admin/registerAdmin", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Admin baru berhasil dibuat!"
                    );
                    this.$bvModal.hide("m-create");
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        prepareEdit(item) {
            this.edit.id = item.id;
            this.edit.name = item.nama;
            this.edit.username = item.username;
            this.edit.password = "";
            this.edit.confirmPassword = "";
            this.$bvModal.show("m-edit");
        },

        confirmEdit() {
            let payload = {
                id: this.edit.id,
                nama: this.edit.name,
                username: this.edit.username,
            };

            if (!this.$helper.isBlank(this.edit.password)) {
                payload["password"] = this.edit.password;
            }

            this.isSubmitting = true;

            this.$axios
                .post("admin/updateAdmin", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Data admin berhasil diubah!"
                    );
                    this.$bvModal.hide("m-edit");
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        confirmToggle(item) {
            let action = item.is_active == 1 ? "nonaktif" : "aktif";

            let isConfirmed = confirm(
                "Apakah anda yakin ingin meng" +
                    action +
                    "kan Admin " +
                    item.nama +
                    "?"
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            let payload = {
                id: item.id,
            };

            this.$axios
                .post("admin/toogleAdmin", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        "Data admin berhasil di" + action + "kan!"
                    );
                    this.getItems(this.currentPage);
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => (this.isSubmitting = false));
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage
            );

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&name=" + this.filter.name;
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param +=
                    "&sortBy=" +
                    (this.sortBy === "role"
                        ? "role_id"
                        : this.sortBy === "active"
                        ? "is_active"
                        : this.sortBy || "id");
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("admin/getAdmins" + param)
                .then((res) => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                    sessionStorage.setItem(
                        "listAdminFilter",
                        JSON.stringify(this.filter)
                    );
                })
                .catch((error) => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },
    },

    computed: {
        inputNameState() {
            if (this.input.name.length <= 0) return null;
            return this.input.name.length >= 4;
        },
        inputUsernameState() {
            if (this.input.username.length <= 0) return null;
            return this.input.username.length >= 4;
        },
        inputPasswordState() {
            if (this.input.password.length <= 0) return null;
            return this.input.password.length >= 4;
        },
        inputConfirmPasswordState() {
            if (this.input.confirmPassword.length <= 0) return null;
            return this.input.confirmPassword == this.input.password;
        },
        editNameState() {
            if (this.edit.name.length <= 0) return null;
            return this.edit.name.length >= 4;
        },
        editUsernameState() {
            if (this.edit.username.length <= 0) return null;
            return this.edit.username.length >= 4;
        },
        editPasswordState() {
            if (this.edit.password.length <= 0) return true;
            return this.edit.password.length >= 4;
        },
        editConfirmPasswordState() {
            if (this.edit.password.length <= 0) return true;
            else if (this.edit.confirmPassword.length <= 0) return null;
            return this.edit.confirmPassword == this.edit.password;
        },
    },

    created() {
        if (!this.$helper.isBlank(sessionStorage.getItem("listAdminFilter"))) {
            this.filter = JSON.parse(sessionStorage.getItem("listAdminFilter"));
        }
        this.init();
    },
};
</script>
